import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, renderList as _renderList } from "vue"
import _imports_0 from './assets/images/logo.jpg'


const _hoisted_1 = {
  id: "app",
  class: "min-h-screen bg-cream-200"
}
const _hoisted_2 = { class: "sticky top-0 z-50 bg-primary-800 shadow-warm border-b border-primary-700/60" }
const _hoisted_3 = { class: "mx-auto max-w-6xl px-4 sm:px-6" }
const _hoisted_4 = { class: "flex h-20 items-center justify-between" }
const _hoisted_5 = { class: "hidden items-center gap-1 lg:flex" }
const _hoisted_6 = { class: "ml-2" }
const _hoisted_7 = {
  key: 1,
  class: "relative ml-2"
}
const _hoisted_8 = ["aria-expanded"]
const _hoisted_9 = {
  key: 0,
  class: "absolute right-0 z-50 mt-2 w-48 overflow-hidden rounded-xl border border-sand-200 bg-white py-1 shadow-warm"
}
const _hoisted_10 = ["aria-expanded"]
const _hoisted_11 = {
  class: "h-6 w-6",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_12 = {
  key: 0,
  d: "M3 12h18M3 6h18M3 18h18"
}
const _hoisted_13 = {
  key: 1,
  d: "M6 18L18 6M6 6l12 12"
}
const _hoisted_14 = {
  key: 0,
  class: "space-y-1 pb-4 lg:hidden"
}
const _hoisted_15 = { class: "bg-primary-900 py-14 text-cream-100" }
const _hoisted_16 = { class: "mx-auto max-w-6xl px-4 sm:px-6" }
const _hoisted_17 = { class: "grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4" }
const _hoisted_18 = { class: "mt-4 space-y-2 text-sm text-primary-200" }
const _hoisted_19 = { class: "mt-4 space-y-2 text-sm text-primary-200" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "group flex items-center gap-3 transition-transform duration-300 hover:-translate-y-0.5"
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Roomsvile Logo",
                class: "h-12 w-12 rounded-lg border-2 border-gold-400/50 object-cover transition-transform duration-300 group-hover:scale-105"
              }, null, -1),
              _createElementVNode("span", { class: "font-display text-2xl font-semibold tracking-tight text-cream-50" }, "Roomsvile", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/",
                class: "nav-link"
              }, {
                default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("svg", {
                    class: "mr-1.5 h-4 w-4",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }, [
                    _createElementVNode("path", { d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" }),
                    _createElementVNode("polyline", { points: "9 22 9 12 15 12 15 22" })
                  ], -1),
                  _createTextVNode(" Home ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/about",
                class: "nav-link"
              }, {
                default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                  _createElementVNode("svg", {
                    class: "mr-1.5 h-4 w-4",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "10"
                    }),
                    _createElementVNode("line", {
                      x1: "12",
                      y1: "16",
                      x2: "12",
                      y2: "12"
                    }),
                    _createElementVNode("line", {
                      x1: "12",
                      y1: "8",
                      x2: "12.01",
                      y2: "8"
                    })
                  ], -1),
                  _createTextVNode(" About ", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/contact",
                class: "nav-link"
              }, {
                default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("svg", {
                    class: "mr-1.5 h-4 w-4",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2"
                  }, [
                    _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
                  ], -1),
                  _createTextVNode(" Contact ", -1)
                ]))]),
                _: 1
              })
            ]),
            (!_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/login",
                      class: "nav-link"
                    }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createElementVNode("svg", {
                          class: "mr-1.5 h-4 w-4",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" }),
                          _createElementVNode("polyline", { points: "10 17 15 12 10 7" }),
                          _createElementVNode("line", {
                            x1: "15",
                            y1: "12",
                            x2: "3",
                            y2: "12"
                          })
                        ], -1),
                        _createTextVNode(" Log In ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_6, [
                    _createVNode(_component_router_link, {
                      to: "/register",
                      class: "flex items-center rounded-lg bg-primary-500 px-4 py-2 text-sm font-semibold text-white shadow-warm-sm transition-colors duration-200 hover:bg-primary-600"
                    }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createElementVNode("svg", {
                          class: "mr-1.5 h-4 w-4",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2"
                        }, [
                          _createElementVNode("path", { d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                          _createElementVNode("circle", {
                            cx: "8.5",
                            cy: "7",
                            r: "4"
                          }),
                          _createElementVNode("line", {
                            x1: "20",
                            y1: "8",
                            x2: "20",
                            y2: "14"
                          }),
                          _createElementVNode("line", {
                            x1: "17",
                            y1: "11",
                            x2: "23",
                            y2: "11"
                          })
                        ], -1),
                        _createTextVNode(" Sign Up ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "nav-link",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accountMenuOpen = !_ctx.accountMenuOpen)),
                    "aria-expanded": _ctx.accountMenuOpen
                  }, [
                    _createTextVNode(" Hi, " + _toDisplayString(_ctx.currentUser?.firstName) + " ", 1),
                    (_openBlock(), _createElementBlock("svg", {
                      class: _normalizeClass(["ml-1.5 h-3.5 w-3.5 transition-transform duration-200", { 'rotate-180': _ctx.accountMenuOpen }]),
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5"
                    }, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("polyline", { points: "6 9 12 15 18 9" }, null, -1)
                    ]))], 2))
                  ], 8, _hoisted_8),
                  (_ctx.accountMenuOpen)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "fixed inset-0 z-40",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.accountMenuOpen = false))
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition duration-150 ease-out",
                    "enter-from-class": "opacity-0 -translate-y-1",
                    "enter-to-class": "opacity-100 translate-y-0",
                    "leave-active-class": "transition duration-100 ease-in",
                    "leave-from-class": "opacity-100",
                    "leave-to-class": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.accountMenuOpen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_router_link, {
                              to: "/profile",
                              class: "block px-4 py-2 text-sm text-ink-700 hover:bg-cream-100",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.accountMenuOpen = false))
                            }, {
                              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                _createTextVNode("My Account", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_router_link, {
                              to: "/bookings",
                              class: "block px-4 py-2 text-sm text-ink-700 hover:bg-cream-100",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.accountMenuOpen = false))
                            }, {
                              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                _createTextVNode("My Bookings", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(_component_router_link, {
                              to: "/favourites",
                              class: "block px-4 py-2 text-sm text-ink-700 hover:bg-cream-100",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.accountMenuOpen = false))
                            }, {
                              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                _createTextVNode("My Favourites", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[26] || (_cache[26] = _createElementVNode("hr", { class: "my-1 border-sand-200" }, null, -1)),
                            _createElementVNode("button", {
                              type: "button",
                              class: "block w-full px-4 py-2 text-left text-sm text-ink-700 hover:bg-cream-100",
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
                            }, " Log Out ")
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "flex h-10 w-10 items-center justify-center rounded-lg text-cream-50 transition-colors hover:bg-white/10 lg:hidden",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mobileMenuOpen = !_ctx.mobileMenuOpen)),
            "aria-expanded": _ctx.mobileMenuOpen,
            "aria-label": "Toggle navigation"
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_11, [
              (!_ctx.mobileMenuOpen)
                ? (_openBlock(), _createElementBlock("path", _hoisted_12))
                : (_openBlock(), _createElementBlock("path", _hoisted_13))
            ]))
          ], 8, _hoisted_10)
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "transition duration-200 ease-out",
          "enter-from-class": "opacity-0 -translate-y-2",
          "enter-to-class": "opacity-100 translate-y-0",
          "leave-active-class": "transition duration-150 ease-in",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            (_ctx.mobileMenuOpen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_router_link, {
                    to: "/",
                    class: "mobile-nav-link",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.mobileMenuOpen = false))
                  }, {
                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                      _createTextVNode("Home", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/about",
                    class: "mobile-nav-link",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.mobileMenuOpen = false))
                  }, {
                    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                      _createTextVNode("About", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    to: "/contact",
                    class: "mobile-nav-link",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.mobileMenuOpen = false))
                  }, {
                    default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                      _createTextVNode("Contact", -1)
                    ]))]),
                    _: 1
                  }),
                  (!_ctx.isAuthenticated)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_router_link, {
                          to: "/login",
                          class: "mobile-nav-link",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.mobileMenuOpen = false))
                        }, {
                          default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                            _createTextVNode("Log In", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          to: "/register",
                          class: "mobile-nav-link",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.mobileMenuOpen = false))
                        }, {
                          default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                            _createTextVNode("Sign Up", -1)
                          ]))]),
                          _: 1
                        })
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_router_link, {
                          to: "/profile",
                          class: "mobile-nav-link",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.mobileMenuOpen = false))
                        }, {
                          default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                            _createTextVNode("My Account", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          to: "/bookings",
                          class: "mobile-nav-link",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.mobileMenuOpen = false))
                        }, {
                          default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                            _createTextVNode("My Bookings", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          to: "/favourites",
                          class: "mobile-nav-link",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.mobileMenuOpen = false))
                        }, {
                          default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                            _createTextVNode("My Favourites", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("button", {
                          type: "button",
                          class: "mobile-nav-link w-full text-left",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => {
                  _ctx.handleLogout();
                  _ctx.mobileMenuOpen = false;
                })
                        }, " Log Out ")
                      ], 64))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_router_view),
    _createElementVNode("footer", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _cache[40] || (_cache[40] = _createElementVNode("div", null, [
            _createElementVNode("h3", { class: "font-display text-xl font-semibold text-cream-50" }, " Roomsvile "),
            _createElementVNode("p", { class: "mt-3 text-sm leading-relaxed text-primary-200" }, " Your trusted partner for hotels and serviced apartments. ")
          ], -1)),
          _createElementVNode("div", null, [
            _cache[38] || (_cache[38] = _createElementVNode("h4", { class: "text-sm font-semibold uppercase tracking-wide text-gold-400" }, " Quick Links ", -1)),
            _createElementVNode("ul", _hoisted_18, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "footer-link"
                }, {
                  default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                    _createTextVNode("Home", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/about",
                  class: "footer-link"
                }, {
                  default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                    _createTextVNode("About Us", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/contact",
                  class: "footer-link"
                }, {
                  default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                    _createTextVNode("Contact Us", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[39] || (_cache[39] = _createElementVNode("h4", { class: "text-sm font-semibold uppercase tracking-wide text-gold-400" }, " Services ", -1)),
            _createElementVNode("ul", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerServices, (service) => {
                return (_openBlock(), _createElementBlock("li", { key: service }, [
                  _createVNode(_component_router_link, {
                    to: "/about#services",
                    class: "footer-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(service), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            ])
          ]),
          _cache[41] || (_cache[41] = _createElementVNode("div", null, [
            _createElementVNode("h4", { class: "text-sm font-semibold uppercase tracking-wide text-gold-400" }, " Contact "),
            _createElementVNode("ul", { class: "mt-4 space-y-2 text-sm text-primary-200" }, [
              _createElementVNode("li", null, "Email: info@roomsvile.com"),
              _createElementVNode("li", null, "Phone: +234 (0) 808 7102 974")
            ])
          ], -1))
        ]),
        _cache[42] || (_cache[42] = _createElementVNode("hr", { class: "my-8 border-primary-700" }, null, -1)),
        _cache[43] || (_cache[43] = _createElementVNode("div", { class: "text-center text-sm text-primary-300" }, [
          _createElementVNode("p", null, "© 2025 Roomsvile. All rights reserved.")
        ], -1))
      ])
    ])
  ]))
}